import type { Options } from '@/scopes/common/components/Filters/Shared'
import { RadioButtonField, RadioButtonGroup } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

export function Root({
  options,
  selectedOption,
  onSelectedValueChange,
  disabled,
}: {
  options: Options[]
  selectedOption: string | undefined
  onSelectedValueChange: (selection: string) => void
  disabled?: boolean
}) {
  return (
    <>
      <RadioButtonGroup
        onValueChange={onSelectedValueChange}
        value={selectedOption}
        defaultValue={selectedOption}
        disabled={disabled}
      >
        {options.map(({ name, value }) => (
          <RadioButtonField
            value={value}
            key={value}
            data-qa={`transport-type-filter-${value}`}
            label={name}
            id={`transport-type-filter-${value}`}
          />
        ))}
      </RadioButtonGroup>
    </>
  )
}
